import { Category } from '@modules/common/types';
import { FeedbackLabelType } from 'v2/core/entities/feedback';
import { ReasonOrEntityLabelType } from 'v2/core/entities/feedback/labels';
import { CATEGORY_ORDER_PRIORITY_ARRAY } from '../constants';

interface GetLabelsToCategoryMapOptions {
  labels: ReasonOrEntityLabelType[];
}

const setLabelsInCategoryMap = (
  categoryMap: Map<Category, ReasonOrEntityLabelType[]>,
  category: Category,
  label: ReasonOrEntityLabelType,
) => {
  const mappedLabels = categoryMap.get(category);
  if (!mappedLabels) {
    categoryMap.set(category, [label]);
    return;
  }
  mappedLabels.push(label);
};

export const getLabelsToCategoryPairArray = ({
  labels,
}: GetLabelsToCategoryMapOptions) => {
  const mappedPredictedCategories = new Map<
    Category,
    ReasonOrEntityLabelType[]
  >();

  for (const label of labels) {
    if (label.type === FeedbackLabelType.Entity) {
      const categorySet = new Set<Category>();
      const entityUnits = label.entityUnits;
      entityUnits?.forEach((unit) => {
        const category = unit.category ?? Category.Uncategorized;
        if (categorySet.has(category)) {
          return;
        }
        setLabelsInCategoryMap(mappedPredictedCategories, category, label);
        categorySet.add(category);
      });
    }

    if (label.type === FeedbackLabelType.Reason && label.category) {
      setLabelsInCategoryMap(mappedPredictedCategories, label.category, label);
    }
  }

  const mappedArray = Array.from(mappedPredictedCategories.entries());

  // Sort the array according to priority index set
  mappedArray.sort((pair1, pair2) => {
    const categoryforPair1 = pair1[0];
    const categoryforPair2 = pair2[0];

    return (
      CATEGORY_ORDER_PRIORITY_ARRAY.indexOf(categoryforPair1) -
      CATEGORY_ORDER_PRIORITY_ARRAY.indexOf(categoryforPair2)
    );
  });

  return mappedArray;
};
